<template>
    <div class="container-data-availability">
        <div>
            <span class="title">Integração de Disponibilidade </span>
            <span class="title-integration">{{ integrationTypeComputed }} </span>
            <span v-if="providerNameComputed">
                <span class="title">com </span>
                <span class="title-integration">{{ providerNameComputed }}</span>
            </span>
        </div>

        <div class="body-availability">
            <div class="body-availability-content">
                <div v-if="menuListComputed.length" class="body-menu-left">
                    <ui-chain-menu v-model="menuListComputed" clickable />
                </div>

                <div class="body-content">
                    <div class="container-title-subtitlte">
                        <span class="title">{{ titleComputed }}</span>
                        <span class="subtitle">{{ subtitle }}</span>
                    </div>

                    <div class="hr" />

                    <availability-form
                        v-if="viewActive === 'availability'"
                        v-model="form"
						:id="id"
                        :integration="integration"
                        @reload="reloadHandler"
                    />

                    <unit-maps-fields
                        v-if="viewActive === 'unit-map-fields'"
                        :id="form.data.id"
						:type="form.data.type"
                        :integration="integration"
						:integration-provider="form.data.integration_provider"
						:data="mapping"
						:loading="loading.mapsFields"
                        @reload="reloadHandler"
					/>

                    <proposal-indexers v-if="viewActive === 'proposal-indexers'" :data="indexers" />

                    <div class="container-footer">
                        <div class="container-button">
                            <ui-button
                                :disabled="!canSubmit"
                                :loading="loading.submit"
                                type="button"
                                design="success lg mw-100"
                                @click="handleButton">
                                <span
                                    v-if="viewActive == 'proposal-indexers'"
                                    :class="[{'container-button-finish': viewActive == 'proposal-indexers'}]">
                                    Finalizar
                                </span>
                                <span v-else class="container-button-save">
                                    Salvar
                                </span>
                                <em :class="[{'far-finish': viewActive == 'proposal-indexers'}]" class="far fa-chevron-right" />
                            </ui-button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container-links-footer">
                <div class="links">
                    <router-link to="/marketing/integracoes/erp/integracoes">
                        <div class="links-integrations-enterprises">Listar Integrações ERP</div>
                    </router-link>

                    <div class="links-line-vertical"/>

                    <router-link to="/marketing/integracoes/erp/empreendimentos">
                        <div class="links-integrations-enterprises">Empreendimentos Integrados</div>
                    </router-link>
                </div>
            </div>
        </div>

        <modal-new-integration />
        <modal-integration-success />
    </div>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons';
	import { uiChainMenu } from '@/components/ui/menus/index.js'
	import availabilityForm from './components/availability-form'
	import unitMapsFields from './components/unit-maps-fields'
	import proposalIndexers from './components/proposal-indexers'
	import modalNewIntegration from './components/modal-new-integration'
	import modalIntegrationSuccess from './components/modal-integration-success'

	import { product, availability, erp } from '@/services/axios';

	import { utilMixin } from '@/mixins'

	import { mapActions, mapGetters } from 'vuex'

	import { defaultMenuList } from './data'

	const lodash = require("lodash")

	const defaultLoading = () => ({
		submit: false,
		mapsFields: false
	})

	const defaultForm = () => ({
		data: {
			id: null,
			type: 'horizontal',
			product: null,
			product_id: null,
			integration_provider_id: null,
			integration_erp_id: null,
			integration_provider: null,
			integration_provider_unity: null,
			integration_provider_name: null,
			infos: {
				stage: null,
				blocks: null,
				sizeBall: 22,
				hide_electronic_plant: false,
				hide_sales_mirror: false,
				towers: null,
				floors: null,
				underground: null,
				units: null,
				groundFloor: false,
				show_unregister_floor: false,
				show_unregister_floor_empty: false,
				show_unregister_units_empty: false,
				showValue: null,
				reserve: null,
				sales_table: null,
				simulation: null
			}
		},
		fields: {
			type: {
				required: true,
				disabled: false
			},
			product_id: {
				required: true,
				disabled: false
			},
			integration_provider: {
				required: true,
				disabled: false
			},
			stage: {
				required: false,
				disabled: false
			},
			blocks: {
				required: true,
				disabled: false
			},
			sizeBall: {
				required: false,
				disabled: false
			},
			showValue: {
				required: false,
				disabled: false
			},
			hide_electronic_plant: {
				required: false,
				disabled: false
			},
			hide_sales_mirror: {
				required: false,
				disabled: false
			},
			towers: {
				required: true,
				disabled: false
			},
			floors: {
				required: true,
				disabled: false
			},
			underground: {
				required: false,
				disabled: false
			},
			units: {
				required: true,
				disabled: false
			},
			groundFloor: {
				required: false,
				disabled: false
			},
			show_unregister_floor: {
				required: false,
				disabled: false
			},
			show_unregister_floor_empty: {
				required: false,
				disabled: true
			},
			show_unregister_units_empty: {
				required: false,
				disabled: true
			},
			reserve: {
				required: false,
				disabled: false
			},
			sales_table: {
				required: false,
				disabled: false
			},
			simulation: {
				required: false,
				disabled: false
			}
		}
	})

	export default {
		name: 'product-integration-form',

		components: {
			uiChainMenu,
			availabilityForm,
			unitMapsFields,
			proposalIndexers,
			uiButton,
			modalNewIntegration,
			modalIntegrationSuccess
		},

		mixins: [utilMixin],

		props: {
			id: {
				type: [String,Number],
				required: false,
				default: 0
			}
		},

		data(){
			return {
				form: { ...defaultForm() },
				mapping: [],
				indexers: [],
				loading: { ...defaultLoading() },
				menuList: [...defaultMenuList()],
				subtitle: 'Faça o mapeamento dos campos para exibir as informações da unidade corretamente.'
			}
		},

		computed: {
			...mapGetters('ERP', {
				integration: 'getSelected',
				availabilityEnabled: 'getAvailabilityEnabled'
			}),
			/**
			 * Computed property que define o tipo de integração utilizada
			 */
			integrationTypeComputed() {
				return this.integration
					? this.integration.type.toUpperCase()
					: ''
			},
			/**
			 * Computed property que define o nome do empreendimento ERP utilizado
			 */
			providerNameComputed() {
				return this.form.data.integration_provider ? this.form.data.integration_provider.name : ''
			},
			/**
			 * Computed property que define quais os passos do cadastro da disponibilidade
			 */
			menuListComputed: {
				get() {
					return this.integration && this.integration.type === 'sienge'
						? this.menuList
						: this.menuList.filter(menu => menu.tag !== 'proposal-indexers')
				},
				set(value) {
					for (const item of value) {
						const index = this.menuList.findIndex(menu => menu.tag === item.tag)
						if (index >= 0) this.menuList[index] = item
					}
				}
			},
			/**
			 * Computed property que define qual a etapa ativa no cadastro de uma disponibilidade
			 */
			viewActive() {
				const active = this.menuListComputed.find(item => item.active)
				return active ? active.tag : ''
			},
			/**
			 * Computed property que define qual a etapa ativa no cadastro de uma disponibilidade
			 */
			viewNext() {
				const next = this.menuListComputed.find(item => item.next)
				return next ? next.tag : false
			},
			/**
			 * Computed property que define o título da etapa currente
			 */
			titleComputed() {
				let title = 'Dados da Disponibilidade'

				switch (this.viewActive) {
					case 'unit-map-fields':
						title = 'Mapear campos das unidades'
						break

					case 'proposal-indexers':
						title = 'Indexadores para Proposta'
						break
				}

				return title
			},
			/**
			 * Computed property que define se o formulário pode ser submetido
			 */
			canSubmit() {
				if(this.viewActive === 'unit-map-fields') {
					return this.validateForm().valid && this.validateRequiredFields()
				}
				return this.validateForm().valid
			}
		},

		created() {
			this.$root.$on('modal-close-new-integration', () => {
				this.set('availability', 'active')
			})

			this.$root.$on('modal-close-integration-success', (payload) => {
				if (payload === 'redirect--new-availability') {
					this.form = { ...defaultForm() }
					this.$root.$emit('modal-open-new-integration')
				}
			})
		},

		mounted: async function () {
			if (!this.availabilityEnabled) {
				this.$toastr.e('O component de Disponibilidade não foi contratado para o motor ERP!')
				this.$router.push({ name: 'marketing.integrations.erp' })
			}

			if (this.id) {
				this.loadData()

			} else if (this.$route.query &&
				this.$route.query.integration_id &&
				this.$route.query.product_id) {
				await this.loadForm()
				this.set('availability', 'active')

			} else {
				this.$root.$emit('modal-open-new-integration')
			}
		},

		beforeDestroy() {
			this.$root.$off('modal-close-new-integration')
			this.$root.$off('modal-close-integration-success')
		},

		methods: {
			...mapActions('ERP', [
				'selectIntegration',
				'removeSelected',
				'setAvailability',
				'selectIntegrationById',
				'setLoading'
			]),
			/**
			 * Carrega os dados dos mapeamentos dos campos das unidades
			 */
			loadUnitMappings() {
				return new Promise((resolve, reject) => {
					this.loading.mapsFields = true
					const params = {
						where: `depara_type:units,availability_id:${this.form.data.id}`
					}
					erp.getAllV2('fields-mapping', params)
						.then(response => {
							this.mapping = [...response.data.data]
							resolve()
						})
						.catch(error => {
							reject(error)
						})
						.finally(() => {
							this.loading.mapsFields = false
						})
				})
			},
			/**
			 * Carrega os dados da integração e da disponibilidade, do mapeamento dos campos
			 * e indexadores caso possua
			 */
			loadData: async function () {
				if (!this.id) return

				try {
					this.setLoading(true)
					// Carrega os dados da disponibilidade
					let response = await availability.getV2('', this.id, {})
					const data = { ...response.data.data }
					const provider = {
						id: `${data.integration_provider_id || ''}`
							+ `.${data.integration_provider || ''}`
							+ `.${data.integration_provider_unity || ''}`,
						name: data.integration_provider_name
					}
					this.form.data = { ...data }
					this.form.data.product_id = data.product.id
					this.form.data.integration_provider = provider
					if (data.integration_erp) {
						this.selectIntegration(data.integration_erp)
						this.set('availability', 'active')

					} else {
						this.$root.$emit('modal-open-new-integration')
					}

					await this.loadUnitMappings()

				} catch (error) {
					if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					console.log(error)

				} finally {
					this.setLoading(false)
				}
			},
			/**
			 * Handler function que trata o evento de quando um novo mapeamento de campos
			 * é adicionado ou removido
			 */
			reloadHandler() {
				this.loadUnitMappings().catch(error => {
					if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					console.log(error)
				})
			},
			/**
			 * Valida a propriedade required dos campos do formulário
			 */
			validateRequired(field, dataField = '') {
				if (!Object.prototype.hasOwnProperty.call(this.form.fields, field)) {
					throw new Error(`Falha ao validar o campo ${field}. Este campo não existe!`)
				}
				dataField = dataField || field
				const required = this.form.fields[field].required
				const validation = this.$mx_hasValue(lodash.get(this.form.data, dataField))

				return (required && validation) || !required
			},
			/**
			 * Valida os campos do formulário de acordo com diferentes conjuntos de regras
			 */
			validateForm() {
				let valid = true
				let message = '<ul>'
				try {
					if (!this.validateRequired('type')) {
						valid = false
						message += '<li>É necessário selecionar o tipo de disponibilidade.</li>'
					}

					if (!this.validateRequired('product_id')) {
						valid = false
						message += '<li>É necessário selecionar um empreendimento Facilita.</li>'
					}

					if (!this.validateRequired('integration_provider')) {
						valid = false
						message += '<li>É necessário selecionar um empreendimento ERP.</li>'
					}

					if (!this.validateRequired('stage', 'infos.stage')) {
						valid = false
						message += '<li>É necessário definir uma etapa para a disponibilidade.</li>'
					}

					if (!this.validateRequired('blocks', 'infos.blocks')) {
						valid = false
						message += '<li>É necessário definir uma quantidade de quadras para a disponibilidade.</li>'
					}

					if (!this.validateRequired('sizeBall', 'infos.sizeBall')) {
						valid = false
						message += '<li>É necessário definir o tamanho do ícone.</li>'
					}

					if (!this.validateRequired('showValue', 'infos.showValue')) {
						valid = false
						message += '<li>É necessário definir se os valores das unidades serão exibidos.</li>'
					}

					if (!this.validateRequired('hide_electronic_plant', 'infos.hide_electronic_plant')) {
						valid = false
						message += '<li>É necessário definir se o Espelho Digital será oculto.</li>'
					}

					if (!this.validateRequired('hide_sales_mirror', 'infos.hide_sales_mirror')) {
						valid = false
						message += '<li>É necessário definir se a Imagem de Implantação será oculta.</li>'
					}

					if (!this.validateRequired('towers', 'infos.towers')) {
						valid = false
						message += '<li>É necessário definir a quantidade de torres do empreendimento.</li>'
					}

					if (!this.validateRequired('floors', 'infos.floors')) {
						valid = false
						message += '<li>É necessário definir a quantidade de andares por torre.</li>'
					}

					if (!this.validateRequired('underground', 'infos.underground')) {
						valid = false
						message += '<li>É necessário definir a quantidade de andares no subsolo.</li>'
					}

					if (!this.validateRequired('units', 'infos.units')) {
						valid = false
						message += '<li>É necessário definir a quantidade de unidades.</li>'
					}

					if (!this.validateRequired('groundFloor', 'infos.groundFloor')) {
						valid = false
						message += '<li>É necessário definir se o térreo será mostrado.</li>'
					}

					if (!this.validateRequired('show_unregister_floor', 'infos.show_unregister_floor')) {
						valid = false
						message += '<li>É necessário definir se os andares altos serão ocultos.</li>'
					}

					if (!this.validateRequired('show_unregister_floor_empty', 'infos.show_unregister_floor_empty')) {
						valid = false
						message += '<li>É necessário definir se os andares vazios serão ocultos.</li>'
					}

					if (!this.validateRequired('show_unregister_units_empty', 'infos.show_unregister_units_empty')) {
						valid = false
						message += '<li>É necessário definir se as unidades vazias serão ocultas.</li>'
					}

				} catch (e) {
					this.$toastr.e(e)
					valid = false
				}
				message += '</ul>'

				return { valid, message }
			},
			/**
			 * Valida se os campos facilitas obrigatorios foram preenchidos
			 */
			validateRequiredFields() {
				const requiredFields = ['block', 'id', 'pos_y', 'pos_x', 'number', 'cost']
				const fieldsInMapping = this.mapping.map(item => item.field_fac)
				const missingFields = requiredFields.filter(field => !fieldsInMapping.includes(field))
				if (missingFields.length > 0) {
					return false
				} else {
					return true
				}

			},
			/**
			 * Handle function que trata o botão que finaliza uma etapa do cadastro
			 */
			async handleButton() {
				this.loading.submit = true
				switch (this.viewActive) {
					case 'availability':
						let params = (({
							type,
							product_id,
							integration_provider,
							infos
						}) => {
							const providerData = integration_provider.id.split('.')
							return {
								typeAvailability: type,
								product_id,
								integration_erp_id: this.integration.id,
								integration_provider_id: providerData[0],
								integration_provider: providerData[1],
								integration_provider_unity: providerData[2],
								integration_provider_name: integration_provider.name,
								infos: { ...infos, cSizeBall: infos.sizeBall }
							}
						})(this.form.data)
						product.updateV2(this.form.data.product_id, 'availability', params)
							.then(response => {
								if (response.data && response.data.msg) this.$toastr.s(response.data.msg)
								this.form.data.id = response.data.data.availability_id
								this.loadUnitMappings()
								this.completeActual()
								this.activeNext()
							})
							.catch(error => {
								if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
								console.log(error)
							})
							.finally(() => {
								this.loading.submit = false
							})
						break

					case 'unit-map-fields':
						/**
						 * essa chamada serve para sincronizar unidades do UAU para
						 * nosso banco de dados
						 */
						try {
							await product.createV2(`${this.form.data.product_id}/syncUnits`)
							this.loading.submit = false
							this.activeNext()
							break
						} catch (error) {
							if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
							this.loading.submit = false
							break
						}
				}
			},
			/**
			 * Altera o status de uma etapa de acordo com sua tag
			 */
			set(tag, prop, bool = true) {
				this.menuListComputed.forEach(item => {
					if (item.tag == tag) item[prop] = bool
				})
			},
			/**
			 * Ativa a próxima etapa do cadastro
			 */
			activeNext() {
				const i = this.menuListComputed.findIndex(item => item.tag == this.viewActive)
				const nextItem = this.menuListComputed[i + 1]

				if (nextItem) {
					this.menuListComputed.forEach(item => {
						if (item.tag == nextItem.tag) item.active = true
						else item.active = false
					})
					this.set(this.viewActive, 'editing')

				} else {
					/** Desativa as etapas do cadastro */
					this.menuListComputed.forEach(item => {
						item.active = false
						item.completed = false
						item.skiped = false
						item.editing = false
					})
					this.removeSelected()
					// Seta os dados da disponibilidade no vuex para ser utilizado no modal
					this.setAvailability(this.form.data)
					this.$root.$emit('modal-open-integration-success')
				}
			},
			/**
			 * Define o status da etapa atual do cadastro como concluída
			 */
			completeActual() {
				this.set(this.viewActive, 'completed')
				this.set(this.viewActive, 'editing', false)
			},
			/**
			 * Carrega os dados do formulário de acordo com os parâmetros da rota
			 */
			loadForm() {
				const params = this.$route.query
				this.form.data.product_id = parseInt(params.product_id)
				// Remove o cookie com o ID da integração
				document.cookie = `product_integration_id=""; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT`
				return this.selectIntegrationById(params.integration_id)
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>